import { CardTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/CardTab/CardTab';
import produce from 'immer';
import { statusOptions } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/helper';
import { IProgramActivityPayload } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/ProgramActivityCard/ProgramActivityCard.types';
import { IActiveTab } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainCard/Common/TabsSection/TabsSection';
import { ITab } from 'components/common/CustomizedTabs/CustomizedTabs';

export const tabsArrData: ITab<IActiveTab>[] = [
    {
        value: 'cardDetails',
        label: <CardTab title={'Card Details'} />,
    },
    {
        value: 'activityDetails',
        label: <CardTab title={'Activity Details'} />,
    },
    {
        value: 'activityRelationships',
        label: <CardTab title={'Activity Relationships'} />,
    },
    {
        value: 'relatedCards',
        label: <CardTab title={'Associated Activities'} />,
    },
    {
        value: 'auditLogs',
        label: <CardTab title={'Audit Log'} />,
    },
];

export const tabsArrDataMobile: ITab<IActiveTab>[] = [
    {
        value: 'cardDetails',
        label: <CardTab title={'Card Details'} />,
    },

    {
        value: 'activityRelationships',
        label: <CardTab title={'Activity Relationships'} />,
    },

    {
        value: 'auditLogs',
        label: <CardTab title={'Audit Log'} />,
    },
];

export const getStatusOptionsByCategory = (category, originalStatus) => {
    if (category && category.toLowerCase().includes('milestone')) {
        return produce(statusOptions, (draft) => {
            return draft
                .filter((item) => item.name !== 'IN_PROGRESS')
                .map((i) => {
                    return { ...i, originalStatus: originalStatus };
                });
        });
    }

    return statusOptions.map((i) => {
        return { ...i, originalStatus: originalStatus };
    });
};

export const buildProgramActivityCardPayload = (data): IProgramActivityPayload => {
    return {
        id: data.id,
        projectId: data.project.id,
        contractId: data.contract.id,
        activityId: data.activityId ? data.activityId.id : null,
        assigneeUserName: data.assignee.value,
        category: data.category.value,
        details: data.details,
        mentionedList: data.mentionedList,
        startDate: data.startDate,
        endDate: data.endDate,
        externalLinks: data.externalLinks,
        externalDocuments: data.externalDocuments,
        status: data.status.name,
        tagList: data.tagList.map((item) => ({ name: item.value })),
        title: data.title,
        relatedCardIds: null,
        type: data.type,
        isImportant: data.isImportant,
        versionId: data.versionId,
        remainingDurationInDays: data.remainingDurationInDays,
        submittedDurationComplete: data.submittedDurationComplete,
    };
};
